
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as hr_45filegdN6500vLFRqmHIy6NTmq9XZP3Z9kFEvk0Wnl84qpb0Meta } from "/app/pages/sid/hr-file.vue?macro=true";
import { default as hr_45noteTzdEhLXizKZqvf7Gho76NMNthIDYGUFLWgWBTzPgOK0Meta } from "/app/pages/sid/hr-note.vue?macro=true";
import { default as ir_45filevYryq0Qtb5LCTDk2zUdS0_45b8JLwC9m29_uLBJ7_DZuAMeta } from "/app/pages/sid/ir-file.vue?macro=true";
import { default as ir_45noteDGKBOttyHsFyL3k1IElLnc_hE3qAyVDoystJFAaK2dwMeta } from "/app/pages/sid/ir-note.vue?macro=true";
import { default as xero_45cardjJZQLt_45RuSCob_45dE0Qjd3Jm7Ojb5KfwkZWAduqeiykAMeta } from "/app/pages/sid/xero-card.vue?macro=true";
import { default as company_45updateFAzY7ayoIF3Y0RK_nQIjbso3qBBN4bNTmT4tFsRL8A8Meta } from "/app/pages/company-update.vue?macro=true";
import { default as legal_45filea8kjMy8cloXD6Rd_457639FxNkZb4GUdfGIFyZ0XHe5cAMeta } from "/app/pages/sid/legal-file.vue?macro=true";
import { default as legal_45noternRZNPRtdynRkCoRCJc95soBOCI3SQ_ug8MzEn5ZB0QMeta } from "/app/pages/sid/legal-note.vue?macro=true";
import { default as lp_45wire_45useOY5UrHdHBrz0dYLVtPhoYQ_P4OcAZEQXcV2xOUZw2oMeta } from "/app/pages/sid/lp-wire-us.vue?macro=true";
import { default as dfpi_45surveymXvNd79SfSwn4ai1nZY98GD6duVUeboOtJxDA0SbpFMMeta } from "/app/pages/sid/dfpi-survey.vue?macro=true";
import { default as legal_45filesmeub_45tedvT0ftp0o8YM0V9XXoxr6sC0aQIBMlGl_45OiUMeta } from "/app/pages/sid/legal-files.vue?macro=true";
import { default as indexUVBClvupsRCX2G6PsxxLFj_Cptg_0DzxwuByyCSKk1MMeta } from "/app/pages/onboarding/index.vue?macro=true";
import { default as companyCUneJyE_45g_45qPsmnwIjNP0x9OrEFlTHb5NvcVEkebCs8Meta } from "/app/pages/profiles/company.vue?macro=true";
import { default as founderWuW2O4t6P7eJfvCxW8Tq3hjCUnMISc3rBqjVskPLnm0Meta } from "/app/pages/profiles/founder.vue?macro=true";
import { default as bank_45accountVoTV75uOIMmPiIGUhVIf_eUOMiwxjmmzesxy0J6rtPIMeta } from "/app/pages/sid/bank-account.vue?macro=true";
import { default as lp_45wire_45intlkvIdiOIo_4593pE93YJtJb6gUzZeFtiNT91jY9pi5L3NMMeta } from "/app/pages/sid/lp-wire-intl.vue?macro=true";
import { default as hr_45onboarding7NsuWpSZ4lFxRL0VwYxu13I2JHg_EH2UBDuNlzSa2sgMeta } from "/app/pages/sid/hr-onboarding.vue?macro=true";
import { default as wallet_45addressJE_45rcbeddWlPJ5WTn840nfroN_0ldgZre2yLP09_448Meta } from "/app/pages/sid/wallet-address.vue?macro=true";
import { default as company_45detailsjyTUO5V3naY_MvLc3eTGN_3LJz8nouEZxLjBmEOLvkMMeta } from "/app/pages/sid/company-details.vue?macro=true";
import { default as bank_45account_45indiaP1PkzuG3IyPikuQqrgTKksueqbB_4hiPzbVezKURArcMeta } from "/app/pages/sid/bank-account-india.vue?macro=true";
import { default as stock_45distributionaAmwj34fqolhPNWaDOaWDj5d3PFah0bO8ZIVxaLvcuEMeta } from "/app/pages/sid/stock-distribution.vue?macro=true";
import { default as contact_45information_DIXsmBnhd5eogjUFAuKpJAne38NfZQgXKkISoj5oPEMeta } from "/app/pages/sid/contact-information.vue?macro=true";
import { default as founder_45due_45diligenceJW0M7pIWXZCiFVaOriTtEeTIcBEzDxey9LGSIcqKfB4Meta } from "/app/pages/sid/founder-due-diligence.vue?macro=true";
import { default as indiebio_45company_45detailseYkB37k8cvlPtQvX_45GYQZbhuCcbRkpWGyVgzG9wDFiQMeta } from "/app/pages/sid/indiebio-company-details.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "sid-hr-file",
    path: "/sid/hr-file",
    component: () => import("/app/pages/sid/hr-file.vue")
  },
  {
    name: "sid-hr-note",
    path: "/sid/hr-note",
    component: () => import("/app/pages/sid/hr-note.vue")
  },
  {
    name: "sid-ir-file",
    path: "/sid/ir-file",
    component: () => import("/app/pages/sid/ir-file.vue")
  },
  {
    name: "sid-ir-note",
    path: "/sid/ir-note",
    component: () => import("/app/pages/sid/ir-note.vue")
  },
  {
    name: "sid-xero-card",
    path: "/sid/xero-card",
    component: () => import("/app/pages/sid/xero-card.vue")
  },
  {
    name: "company-update",
    path: "/company-update",
    component: () => import("/app/pages/company-update.vue")
  },
  {
    name: "sid-legal-file",
    path: "/sid/legal-file",
    component: () => import("/app/pages/sid/legal-file.vue")
  },
  {
    name: "sid-legal-note",
    path: "/sid/legal-note",
    component: () => import("/app/pages/sid/legal-note.vue")
  },
  {
    name: "sid-lp-wire-us",
    path: "/sid/lp-wire-us",
    component: () => import("/app/pages/sid/lp-wire-us.vue")
  },
  {
    name: "sid-dfpi-survey",
    path: "/sid/dfpi-survey",
    component: () => import("/app/pages/sid/dfpi-survey.vue")
  },
  {
    name: "sid-legal-files",
    path: "/sid/legal-files",
    component: () => import("/app/pages/sid/legal-files.vue")
  },
  {
    name: "onboarding",
    path: "/onboarding",
    component: () => import("/app/pages/onboarding/index.vue")
  },
  {
    name: "profiles-company",
    path: "/profiles/company",
    component: () => import("/app/pages/profiles/company.vue")
  },
  {
    name: "profiles-founder",
    path: "/profiles/founder",
    component: () => import("/app/pages/profiles/founder.vue")
  },
  {
    name: "sid-bank-account",
    path: "/sid/bank-account",
    component: () => import("/app/pages/sid/bank-account.vue")
  },
  {
    name: "sid-lp-wire-intl",
    path: "/sid/lp-wire-intl",
    component: () => import("/app/pages/sid/lp-wire-intl.vue")
  },
  {
    name: "sid-hr-onboarding",
    path: "/sid/hr-onboarding",
    component: () => import("/app/pages/sid/hr-onboarding.vue")
  },
  {
    name: "sid-wallet-address",
    path: "/sid/wallet-address",
    component: () => import("/app/pages/sid/wallet-address.vue")
  },
  {
    name: "sid-company-details",
    path: "/sid/company-details",
    component: () => import("/app/pages/sid/company-details.vue")
  },
  {
    name: "sid-bank-account-india",
    path: "/sid/bank-account-india",
    component: () => import("/app/pages/sid/bank-account-india.vue")
  },
  {
    name: "sid-stock-distribution",
    path: "/sid/stock-distribution",
    component: () => import("/app/pages/sid/stock-distribution.vue")
  },
  {
    name: "sid-contact-information",
    path: "/sid/contact-information",
    component: () => import("/app/pages/sid/contact-information.vue")
  },
  {
    name: "sid-founder-due-diligence",
    path: "/sid/founder-due-diligence",
    component: () => import("/app/pages/sid/founder-due-diligence.vue")
  },
  {
    name: "sid-indiebio-company-details",
    path: "/sid/indiebio-company-details",
    component: () => import("/app/pages/sid/indiebio-company-details.vue")
  }
]